import {Component, Vue} from "vue-property-decorator";
import {getMessageRemindById} from "@/api/message";
import commonData from "@/utils/commonData";

const projectTypeList = commonData.projectTypeAllArray
@Component({
    filters: {
        typeFilter: (val: number) => {
            const item = projectTypeList.filter(item => item.value === val)[0]
            return item ? item.label : ''
        }
    }
})
export default class AllProjectRemind extends Vue {
    infoData: object = {}
    types = ''
    costList = [{name: '', price: ''}]
    projectAllShowDepartmentList = []
    projectAllShowUserList = []
    checkUserInfo: any = []
    loading = false

    get allCostNum() {
        let num = 0
        this.costList.forEach(item => num += item.price ? Number(item.price) : 0)
        return num
    }

    // created
    created() {
        //  获取地址栏里的参数
        const url = window.location.href
        const p = url.split('?')[1]
        const params = new URLSearchParams(p)
        const recordId = params.get('id')
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.getMsgData(recordId)
    }

    // methods
    async getMsgData(id) {
        this.loading = true
        await getMessageRemindById({id: id}).then((data: any) => {
            this.infoData = data.result.messageRemindInfo
            const {projectAllCostList, projectAllShowUserList, isShow} = data.result.messageRemindInfo
            this.costList = projectAllCostList ? projectAllCostList.length > 0 ? projectAllCostList : [{
                name: '',
                price: ''
            }] : []

            projectAllShowUserList.map(item => {
                this.checkUserInfo.push({
                    user: {
                        id: item.userId,
                        realName: item.userRealName
                    },
                    userId: item.userId
                })
            })

            this.projectAllShowUserList = isShow === '共享人员' ? projectAllShowUserList : []
            this.loading = false
        }).catch((err: any) => {
            this.loading = false
        })

    }
}